export default "__VITE_ASSET__D7dk4tpv__"